// import {get, post, qspost, put, deletefn} from '@/api/axios'
import {postfile, qspost} from '@/plugins/axios'

/*
 * 班子列表接口
 * */
export const getCadresTribuneList = (type,searchName,searchSex,searchEducation,page,limit) => qspost('/api/user/index', {type,searchName,searchSex,searchEducation,page,limit})

/*
 * 班子列表接口
 * */
export const getOrganizationList = (type,searchName,searchSex,searchEducation,page,limit) => qspost('/api/user/getList', {type,searchName,searchSex,searchEducation,page,limit})

/*
 * 班子列表导出
 * */
export const exportCadresTribune = (type,searchName,searchSex,searchEducation,is_export = 1) => postfile('/api/user/index', {type,searchName,searchSex,searchEducation,is_export})

/*
 * 班子|党员接口
 * type 1 录入党员信息 2 班子信息
 * */
export const addCadresTribuneMember = (img,name,sex,nation,native_place,education,birthday,member_type,add_date,duty,duty_type,rank,
                                       type = 2) => qspost('/api/user/add', {img,name,sex,nation,
    native_place,education,birthday,member_type,add_date,duty,duty_type,rank,type})

/*
 * 班子|党员接口
 * type 1 录入党员信息 2 班子信息
 * */
export const updateCadresTribuneMember = (id,img,name,sex,nation,native_place,education,birthday,member_type,add_date,duty,duty_type,rank,
                                       type = 2) => qspost('/api/user/add', {id,img,name,sex,nation,
    native_place,education,birthday,member_type,add_date,duty,duty_type,rank,type})


/*
 * 班子|党员接口
 * type 1 录入党员信息 2 班子信息
 * */
export const addPartyMember = (img,party_branch,name,sex,nation,address,education,birthday,add_date,occupation,
                                       duty,phone,is_ld,is_party_member,is_ys,is_yb,is_kd,is_record,remark, type = 1) => qspost('/api/user/add', {img,party_branch,name,sex,nation,address,education,birthday,add_date,occupation,
    duty,phone,is_ld,is_party_member,is_ys,is_yb,is_kd,is_record,remark, type})

/*
 * 班子|党员接口
 * type 1 录入党员信息 2 班子信息
 * */
export const updatePartyMember = (id,img,party_branch,name,sex,nation,address,education,birthday,add_date,occupation,
                                       duty,phone,is_ld,is_party_member,is_ys,is_yb,is_kd,is_record,remark, type = 1) => qspost('/api/user/save', {id,img,party_branch,name,sex,nation,address,education,birthday,add_date,occupation,
    duty,phone,is_ld,is_party_member,is_ys,is_yb,is_kd,is_record,remark, type})

/*
 * 党员接口——详情
 * */
export const getMemberInfo = (type,id) => qspost('/api/user/detail', {type,id})

/*
 * 班子|党员接口—删除
 * */
export const delMember = (id) => qspost('/api/user/del', {id})



/*
 * 决策议事——列表
 * 1 党员大会 2 委员会 3 小组会
 * */
export const getMeetingList = (type,searchName,page,limit) => qspost('/api/Meeting/index', {type,searchName,page,limit})

/*
 * 决策会议——导出word
 * */
export const exportMeeting = (type,id) => postfile('/api/Meeting/exportMeeting', {type,id})

/*
 * 会前准备——新增||修改（党员|委员会）
 * 1 党员大会 2 委员会 3 小组会
 * */
export const addMeetingIssue= (type,id,title,meeting_time,address,meeting_file,content) => qspost('/api/Meeting/creInitialize', {type,id,title,meeting_time,address,meeting_file,content})

/*
 *会议程序——修改
 * */
export const addMeetingProcedure= (id,ought_num,solid_num,absent_num,absent_remark,speak_remark,opinion,vote_table,meeting_remark,is_storage
) => qspost('/api/Meeting/procedureSave', {id,ought_num,solid_num,absent_num,absent_remark,speak_remark,opinion,vote_table,meeting_remark,is_storage})

/*
 *会议落实——修改
 * */
export const addMeetingWorkable= (id,title,content,is_storage
) => qspost('/api/Meeting/practicableSave', {id,title,content,is_storage})

/*
 *党小组——新增||修改
 * */
export const addGroupMeeting= (id,title,meeting_time,address,sponsor,emcee,note_taker,participant,absent_remark,content
) => qspost('/api/Meeting/crePartyGroup', {id,title,meeting_time,address,sponsor,emcee,note_taker,participant,absent_remark,content})

/*
 * 会议纪要——列表
 * */
export const getMeetingTemplates = () => qspost('/api/Meeting/meetingLog', {})

/*
 * 决策议事——详情（决策议事内通用接口）
 * */
export const getMeetingDetail = (id) => qspost('/api/Meeting/detail', {id})

/*
 * 决策议事——删除
 * */
export const delMeeting = (id) => qspost('/api/Meeting/del', {id})

/*
 * 活动主题列表
 * */
export const getThemeActivitiesList = (searchName,page,limit) => qspost('/api/Activity/index', {searchName,page,limit})

/*
 * 活动主题列表
 * */
export const exportThemeActivities = (searchName,id,is_export = 1) => postfile('/api/Activity/index', {searchName,id,is_export})

/*
 * 活动主题分类详情
 * */
export const getThemeActivitiesDetail = (id) => qspost('/api/Activity/detail', {id})

/*
 * 制作活动计划
 * */
export const addThemeActivities = (id,content) => qspost('/api/Activity/add', {id,content})

/*
 * 组织开展活动
 * */
export const addThemeActivitiesContent = (id,content,activity_time,meun_id,remark) => qspost('/api/Activity/addLaunch', {id,content,activity_time,meun_id,remark})

/*
 * 总结记录
 * */
export const addThemeActivitiesSummary = (id,content,meun_id,remark,brief_report) => qspost('/api/Activity/addReport', {id,content,meun_id,remark,brief_report})

/*
 * 组织活动——删除
 * */
export const delThemeActivities = (id) => qspost('/api/Activity/del', {id})

/*
 * 活动主题分类
 * */
export const getThemeClassifyList = () => qspost('/api/Activity/activityList', {})

/*
 * 党员示范岗|责任岗——列表
 * */
export const getStationList = (type,searchName,searchDuty,page,limit) => qspost('/api/user/partyList', {type,searchName,searchDuty,page,limit})

/*
 * 党员示范岗|责任岗——列表
 * */
export const exportStationList = (type) => postfile('api/user/partyExceipt', {type})

/*
 * 党员下拉列表——组织活动模块使用
 * */
export const getStationMembers = () => qspost('/api/user/partyMemberList', {})

/*
 * 示范岗|责任岗—详情
 * */
export const getStationDetail = (type,id) => qspost('/api/user/detailDemonstrate', {type,id})

/*
 * 党员示范岗——新增xi修改
 * */
export const addDemonstrate = (id,party_branch,duty,img) => qspost('/api/user/addDemonstrate', {id,party_branch,duty,img})

/*
 * 党员责任岗——新增xi修改
 * */
export const addTurnout = (id,occupation,duty,turnout_area,img) => qspost('/api/user/addTurnout', {id,occupation,duty,turnout_area,img})

/*
 * 示范岗|责任岗—删除
 * */
export const delStation = (type,id) => qspost('/api/user/delDemonstrate', {type,id})



/*
 * 经费经费列表
 * */
export const fundingList = (page,limit) => qspost('/api/index/fundingList', {page,limit})

/*
 * 经费经费列表
 * */
export const fundingDetail = (id) => qspost('/api/index/fundingDetail', {id})

/*
 * 经费经费列表
 * */
export const delFunding = (id) => qspost('/api/index/fundingDel', {id})

/*
 * 经费新增
 * */
export const addFunding = (name,type,funding_time,amount,file_url,remark,content) => qspost('/api/index/addFunding', {name,type,funding_time,amount,file_url,remark,content})

/*
 * 经费新增
 * */
export const fundingSave = (id,name,type,funding_time,amount,file_url,remark,content) => qspost('/api/index/fundingSave', {id,name,type,funding_time,amount,file_url,remark,content})




/*
 * 职责清单——列表
 * */
export const getStandardDutyList = (searchName,page,limit) => qspost('/api/Activity/activeList', {searchName,page,limit})

/*
 * 决策会议——导出word
 * */
export const exportActivity = (active_type,id) => postfile('/api/Activity/exportActivity', {active_type,id})

/*
 * 职责清单—添加
 * */
export const addStandardDuty = (id,title,content) => qspost('/api/Activity/activeSave', {id,title,content})

/*
 * 职责清单——详情
 * */
export const getStandardDutyDetail = (id) => qspost('/api/Activity/activeDetail', {id})

/*
 * 职责清单——删除
 * */
export const delStandardDuty = (id) => qspost('/api/Activity/activeDel', {id})


/*
 * 模板列表
 * */
export const getTemplateList = (searchName,type,page,limit) => qspost('/api/Template/index', {searchName,type,page,limit})

/*
 * 模板列表
 * */
export const getTemplateDetail = (id) => qspost('/api/Template/detail', {id})


/*
 * 党支部工作记录
 * */
export const getWorkRecordList = (searchName,page,limit) => qspost('/api/Material/getWorkRecordList', {searchName,page,limit})

/*
 * 党支部工作记录（详情
 * */
export const getWorkRecordDetail = (id) => qspost('/api/Material/getWorkRecordDetail', {id})

/*
 * 党支部工作记录（删除
 * */
export const delWorkRecordDetail = (id) => qspost('/api/Material/delWorkRecordDetail', {id})

/*
 * 党支部工作记录（增加
 * */
export const addWorkRecord = (id,title,activity_time,address,emcee,note_taker,theme,ought_num,solid_num,
                              absent_num,absent_remark,remark,content) => qspost('/api/Material/setWorkRecord', {
    id,title,activity_time,address,emcee,note_taker,theme,ought_num,solid_num,
    absent_num,absent_remark,remark,content
})

/*
 * 党支部工作记录 导出
 * */
export const exportWorkRecord  = (searchName,id) => postfile('/api/Material/exportWorkRecord', {searchName,id})


/*
 * 总结|计划——列表
 * 1 总结详情 2 计划详情 3 其他类数据（暂时先可以查询，估计还会改数据来源）
 * */
export const getReportMaterialList = (type,searchName,page,limit) => qspost('/api/Material/conclusionList', {type,searchName,page,limit})

/*
 * 总结|计划——列表
 * 1 总结详情 2 计划详情 3 其他类数据（暂时先可以查询，估计还会改数据来源）
 * */
export const exportReportMaterial = (type,id) => postfile('/api/Material/exportMaterial', {type,id})

/*
 * 总结|计划|其他——详情
 * 1 总结详情 2 计划详情 3 其他类数据（暂时先可以查询，估计还会改数据来源）
 * */
export const getReportMaterialDetail = (id,type) => qspost('/api/Material/conclusionDetail', {id,type})

/*
 * 总结-类型
 * */
export const getReportMaterialTypes = () => qspost('/api/index/index', {})

/*
 * 总结|计划|其他——详情
 * 1 总结详情 2 计划详情 3 其他类数据（暂时先可以查询，估计还会改数据来源）
 * */
export const delReportMaterial = (id) => qspost('/api/Material/del', {id})

/*
 * 总结——添加
 * */
export const addReportMaterialConclusion = (id,title,content,meeting_file,type,activity_time,is_storage) => qspost('/api/Material/conclusionAdd', {id,title,content,meeting_file,type,activity_time,is_storage})

/*
 * 计划—添加|修改
 * */
export const addReportMaterialPlan = (id,title,meeting_time,address,meeting_file,content,is_storage) => qspost('/api/Material/planAdd', {id,title,meeting_time,address,meeting_file,content,is_storage})

/*
 * 计划—添加|修改
 * */
export const addReportMaterialOther = (id,title,meeting_time,address,meeting_file,content,is_storage) => qspost('/api/Material/otherAdd', {id,title,meeting_time,address,meeting_file,content,is_storage})

/*
 * 工作流程
 * */
export const backActiveList = (searchName,page,limit) => qspost('/api/Screen/backActiveList', {searchName,page,limit})

/*
 * 工作流程
 * */
export const backActiveDetail = (id) => qspost('/api/Screen/backActiveDetail', {id})


/*
 * 阵地建设——列表
 * 1 设计模板 2 内容素材 3 现场照片
 * */
export const constructionsList = (type,searchName,page,limit) => qspost('/api/Screen/constructionsList', {type,searchName,page,limit})


/*
 * 阵地建设——添加
 * 1 设计模板 2 内容素材 3 现场照片
 * */
export const addConstructions = (id,title,img,content) => qspost('/api/Screen/saveImg', {id,title,img,content})


/*
 * 阵地建设— 详情
 * 1 设计模板 2 内容素材 3 现场照片
 * */
export const getConstructionsDetail = (id) => qspost('/api/Screen/detailImg', {id})


/*
 * 阵地建设——删除
 * 1 设计模板 2 内容素材 3 现场照片
 * */
export const delConstructions = (id) => qspost('/api/Screen/imgDel', {id})


/*
 * 通知列表
 * */
export const notificationList = () => qspost('/api/index/notificationList', {})


/*
 * 通知列表
 * */
export const setNotification = (id,is_show) => qspost('/api/index/setNotification', {id,is_show})


/*
 * 通知列表
 * */
export const addNotification = (id,title,content,notification_file) => qspost('/api/index/notification', {id,title,content,notification_file})


/*
 * 修改密码
 * */
export const changeUserPass = (username,password,new_password,agen_new_password) => qspost('/api/login/changeUserPass', {username,password,new_password,agen_new_password})


/*
 * 获取权限人员
 * */
export const getOrgMemberPower = (power) => qspost('/api/Sonadmin/getOrgMember', {power})


/*
 * 获取权限人员
 * */
export const setMemberPower = (power,id,role ) => qspost('/api/Sonadmin/setMemberPower', {power,id,role})

/*
 * 获取权限
 * */
export const checkPermission = (member_id) => qspost('/api/Sonadmin/getMemberPower', {member_id})




